<template>
	<el-button type="danger" :size="size" :disabled="isdisabled" @click="DoCancel"><i class="fa fa-ban"></i>&nbsp;作废</el-button>
</template>
<script>
	/**
	* 作废按钮
	* @author wxq
	* @time 2017.9.18
	* @param infoId 【description: ID,如12】
	* @param isdisabled 【description: 是否禁用,true,false】
	* @param isRoute 【description: 路由】
	* @param isStyle 【description: 类型 , 如 三包登记，三包理赔】
	*/
	export default {
		name: 'LyBnttonInvalid',
		props: {
			infoId: {
				type: String,
				default: ''
			}, 
			isdisabled: {
				type: Boolean,
				default: false
			},
			isRoute: {
				type: String,
				default: ''
			},
			isStyle: {
				type: String,
				default: ''
			},
			size: {
				type: String,
				default: ''
			},
			// 作废完成后的回调函数
			callback: Function 
		},
		methods: {
			DoCancel () {
				this.$confirm('确认要作废本' + this.isStyle + '单吗？','作废提醒',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
          			type: 'warning',
				}).then(() => {
					this.$api.delete(this.isRoute + '/' + this.infoId).then((rs) => {
						// this.isdisabled = true
						this.$message({
				            type: 'success',
				            message: '本单已被成功作废.'
				        })
				        // 调用回调函数
				        this.callback()
					}).catch((msg) => {
						this.$alert(msg,'单据作废提醒',{
							confirmButtonText: '确定',
		          			callback: action => {
					          	this.$message({
						            type: 'info',
						            message: '本单作废操作失效'
						        })  
					        }
						})
					})
				}).catch(() => {
					this.$message({
			            type: 'info',
			            message: '已取消本单作废操作！'
			        })  
				})
			}
		}
	}
</script>